import React from "react";
import { logError } from "../lib/errors";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    logError(error, { componentStack: info.componentStack ?? undefined });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white px-6 text-center">
          <p className="text-lg font-semibold text-gray-800 mb-2">
            エラーが発生しました
          </p>
          <p className="text-sm text-gray-500 mb-6">
            お手数ですが、画面を再読み込みしてください。
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-2 rounded-full bg-blue-500 text-white text-sm font-medium"
          >
            再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
